module.exports = __webpack_public_path__ + "static/1_3_000-28a259cff0acda35400eef8af107ea34.jpg";